import { IS_ASSIGNED, RESET_STORE, SET_IS_VALID_LOGIN } from "../types";

const initialState = {
  isValidLogin: true,
  messageError: "",
  email: "",
  password: "",
};

export const loginReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_IS_VALID_LOGIN:
      return { ...state, ...payload };
    case IS_ASSIGNED:
      return { ...state, ...payload };
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};
